module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-white.cff0e1c1.svg";